module.exports = __webpack_public_path__ + "static/img/4.7aebdaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/4.png
// module id = j102
// module chunks = 0